/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.eddie.ChannelMode
*/
export var ChannelMode;
(function (ChannelMode) {
    ChannelMode["VERBATIM"] = "VERBATIM";
    ChannelMode["MILESTONES"] = "MILESTONES";
    ChannelMode["SUMMARY"] = "SUMMARY";
    ChannelMode["INBOX"] = "INBOX";
})(ChannelMode || (ChannelMode = {}));
//# sourceMappingURL=ChannelMode.js.map